// Formats a US phone number as the user types: "(555) 123-4567".
// Accepts any input; non-digits are stripped. Up to 10 digits used;
// extra digits ignored. Empty input returns empty string.
// Leading "1" country code (as in "+1 555 ..." or "1-555-...") is
// dropped so the user still gets the 10-digit US format.
export function formatPhone(value: string): string {
  let digits = value.replace(/\D/g, "");
  if (digits.length === 11 && digits.startsWith("1")) {
    digits = digits.slice(1);
  }
  digits = digits.slice(0, 10);
  if (digits.length === 0) return "";
  if (digits.length < 4) return digits;
  if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}
